import request  from '../utils/request'
import { activityGrantUrl, isGrantUrl} from './apiConfig';

// 发券
export const activityGrant = (params = {}) => request(`${activityGrantUrl}`, {
  params
}, {needToken: true, moreClick: false});

// 获取用户已领券信息
export const isActivityGrant = (params = {}) => request(`${isGrantUrl}`, {
  params
}, {needToken: true});